import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageService } from './@modules/components/message/message.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { RoleService } from './@core/guards/role.service';
import { NavigationLayout } from './@modules/layouts/navigation/navigation.component';
import { pagesToggleService } from './@modules/layouts/toggler/toggler.service';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { HorizontalMenuComponent } from './@modules/horizontal-menu/horizontal-menu.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './@modules/components/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGaurd } from './@core/guards/auth-guard.service';
import { RoleGuard } from './@core/guards/role-guard';
import { JwtInterceptor } from './@core/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './@core/interceptors/error.interceptor';
import { EncodeHttpParamsInterceptor } from './@core/interceptors/http.interceptor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertService } from './@modules/alert/alert.service';
import { StylePaginatorDirective } from './@modules/pagination';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export class AppHammerConfig extends HammerGestureConfig {
	overrides = <any>{
	  'pinch': { enable: true },
	  'rotate': { enable: false }
	}
  }

@NgModule({
  bootstrap: [
    AppComponent
  ],
  declarations: [
    AppComponent,
	NavigationLayout,
	HorizontalMenuComponent,
	StylePaginatorDirective,
  ],
  imports: [
    AppRoutingModule,
	HttpClientModule,
	NgbDropdownModule,
	BrowserAnimationsModule,
	SharedModule,
		OverlayModule,
	PerfectScrollbarModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CoreModule.forRoot(),
	NgxPermissionsModule.forRoot(),
    ThemeModule.forRoot(),
	ModalModule.forRoot()
  ],
  providers: [
	MessageService, RoleService, pagesToggleService, NgxPermissionsService,
	AuthGaurd, RoleGuard, RoleService, AlertService,
	{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: EncodeHttpParamsInterceptor, multi: true },
	{
	  provide: HAMMER_GESTURE_CONFIG,
	  useClass: AppHammerConfig
	},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  	]
})
export class AppModule { }
